import {Type, Event}  from "main.core";
import {MainUiFilter} from "./mainUiFilter";
import {MainUiGrid}   from "./mainUiGrid";
import {ListsElementEdit} from "./listsElementEdit";
import {UiToolbar} from "./uiToolbar";
import {TasksTask} from "./tasksTask";

export class Template {
    constructor(options = {name: "Template"}) {
		this._name = options.name;
        this._mainUiGrid = null;

        this.init();
	}

    init() {
        new MainUiFilter(); // main.ui.filter component's customization
        this._mainUiGrid = new MainUiGrid();   // main.ui.grid component's customization
        new ListsElementEdit(); // lists.element.edit
        new UiToolbar(); // lists menu editing
        new TasksTask();
    }

    getMainUiGrid() {
        return this._mainUiGrid;
    }

	getName() {
		return this._name;
	}
}

let obTemplate = new Template();
export {obTemplate};
